import React from "react";
import { TvDiv } from "@trustvid/design-system";

/**
 * Full-page ambient visuals shared by feature + form columns (unified auth canvas).
 */
const AuthBodyCanvas = () => (
  <TvDiv className="tv-login-page__body-canvas" aria-hidden="true" data-testid="auth-body-canvas">
    <TvDiv className="tv-login-page__body-canvas-base" />
    <TvDiv className="tv-login-page__body-canvas-noise" />
    <TvDiv className="tv-login-page__body-canvas-glow tv-login-page__body-canvas-glow--primary" />
    <TvDiv className="tv-login-page__body-canvas-glow tv-login-page__body-canvas-glow--accent" />
    <TvDiv className="tv-login-page__body-canvas-glow tv-login-page__body-canvas-glow--bridge" />
    <TvDiv className="tv-login-page__body-canvas-glow tv-login-page__body-canvas-glow--hero" />
    <TvDiv className="tv-login-page__body-canvas-orb tv-login-page__body-canvas-orb--one" />
    <TvDiv className="tv-login-page__body-canvas-orb tv-login-page__body-canvas-orb--two" />
    <TvDiv className="tv-login-page__body-canvas-mesh tv-login-page__body-canvas-mesh--one" />
    <TvDiv className="tv-login-page__body-canvas-mesh tv-login-page__body-canvas-mesh--two" />
  </TvDiv>
);

export default AuthBodyCanvas;
